import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PageStateService {

  save<T>(key: string, state: T): void {
    sessionStorage.setItem(key, JSON.stringify(state));
  }

  load<T>(key: string): T | null {
    const state = sessionStorage.getItem(key);

    return state ? JSON.parse(state) as T : null;
  }

  clear(key: string): void {
    sessionStorage.removeItem(key);
  }

  setFlag(key: string): void {
    sessionStorage.setItem(key, 'true');
  }

  consumeFlag(key: string): boolean {
    const exists = sessionStorage.getItem(key) === 'true';
    sessionStorage.removeItem(key);

    return exists;
  }
}